
/**
 * The base spacing styles for the theme.
 * You can add new spacing values using this file.
 * You can customize the spacing for the entire theme using this file.
 */

// Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

// types
export interface Types {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
  xxxl: string;
  // Dynamic spacing: number * 2 = pixels (e.g., spacing2 = 4px, spacing3 = 6px)
  spacing2: string;   // 4px (2 * 2)
  spacing2_5: string; // 5px (2.5 * 2)
  spacing3: string;   // 6px (3 * 2)
  spacing4: string;   // 8px (4 * 2)
  spacing5: string;   // 10px (5 * 2)
  spacing6: string;   // 12px (6 * 2)
  spacing7: string;   // 14px (7 * 2)
  spacing8: string;   // 16px (8 * 2)
  spacing9: string;   // 18px (9 * 2)
  spacing10: string;  // 20px (10 * 2)
  spacing11: string;  // 22px (11 * 2)
  spacing12: string;  // 24px (12 * 2)
  spacing12_5: string; // 25px (12.5 * 2)
  spacing14: string;  // 28px (14 * 2)
  spacing15: string;  // 30px (15 * 2)
  spacing16: string;  // 32px (16 * 2)
  spacing20: string;  // 40px (20 * 2)
  spacing21: string;  // 42px (21 * 2)
  spacing22: string;  // 44px (22 * 2)
  spacing25: string;  // 50px (25 * 2)
  spacing28: string;  // 56px (28 * 2)
  spacing31_5: string; // 63px (31.5 * 2)
  spacing32_5: string; // 65px (32.5 * 2)
  spacing33: string;   // 66px (33 * 2)
  spacing35: string;  // 70px (35 * 2)
  spacing50: string;  // 100px (50 * 2)
  spacing59: string;  // 118px (59 * 2)
}

const spacing: Types = {
  // Standard spacing scale
  xs: pxToRem(8),      // 8px
  sm: pxToRem(12),     // 12px
  md: pxToRem(16),     // 16px
  lg: pxToRem(24),     // 24px
  xl: pxToRem(32),     // 32px
  xxl: pxToRem(48),    // 48px
  xxxl: pxToRem(64),   // 64px

  // Dynamic spacing: number * 2 = pixels
  spacing2: pxToRem(4),      // 2 * 2 = 4px
  spacing2_5: pxToRem(5),    // 2.5 * 2 = 5px
  spacing3: pxToRem(6),      // 3 * 2 = 6px
  spacing4: pxToRem(8),      // 4 * 2 = 8px
  spacing5: pxToRem(10),     // 5 * 2 = 10px
  spacing6: pxToRem(12),     // 6 * 2 = 12px
  spacing7: pxToRem(14),     // 7 * 2 = 14px
  spacing8: pxToRem(16),     // 8 * 2 = 16px
  spacing9: pxToRem(18),     // 9 * 2 = 18px
  spacing10: pxToRem(20),    // 10 * 2 = 20px
  spacing11: pxToRem(22),    // 11 * 2 = 22px
  spacing12: pxToRem(24),    // 12 * 2 = 24px
  spacing12_5: pxToRem(25),  // 12.5 * 2 = 25px
  spacing14: pxToRem(28),    // 14 * 2 = 28px
  spacing15: pxToRem(30),    // 15 * 2 = 30px
  spacing16: pxToRem(32),    // 16 * 2 = 32px
  spacing20: pxToRem(40),    // 20 * 2 = 40px
  spacing21: pxToRem(42),    // 21 * 2 = 42px
  spacing22: pxToRem(44),    // 22 * 2 = 44px
  spacing25: pxToRem(50),    // 25 * 2 = 50px
  spacing28: pxToRem(56),    // 28 * 2 = 56px
  spacing31_5: pxToRem(63),  // 31.5 * 2 = 63px
  spacing32_5: pxToRem(65),  // 32.5 * 2 = 65px
  spacing33: pxToRem(66),    // 33 * 2 = 66px
  spacing35: pxToRem(70),    // 35 * 2 = 70px
  spacing50: pxToRem(100),   // 50 * 2 = 100px
  spacing59: pxToRem(118),   // 59 * 2 = 118px
};

export default spacing;




